import { create } from "zustand";
import { ILoginHistoryFilter } from "../api/types";
import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { PostModel } from "common/models/baseModel";
import dayjs from "dayjs";

export interface LoginHistoryStore {
  postModel: PostModel<ILoginHistoryFilter>;
  handleFiltering: (filter: ILoginHistoryFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;
  handleSorting: (sortModel: GridSortModel) => void;
}

const useLoginHistoryStore = create<LoginHistoryStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 10,
    },
    filterModel: {
      fromDate: dayjs().subtract(1, "year").toDate(),
      toDate: dayjs().toDate(),
    },
  },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: ILoginHistoryFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
}));

export default useLoginHistoryStore;
